/**
 * Returns a new callback ref that effectively merges all provided `refs`
 * @param refs
 */
function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return function (instance) {
    refs.forEach(function (ref) {
      if (typeof ref === "function") {
        ref(instance);
      } else if (ref) {
        // eslint-disable-next-line no-param-reassign
        ref.current = instance;
      }
    });
  };
}

export { mergeRefs as default };
//# sourceMappingURL=mergeRefs.js.map
